import {
  BOOK_APPOINTMENT_REQUEST,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_FAILURE,
  FETCH_APPOINTMENTS_REQUEST,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_FAILURE,
  CANCEL_APPOINTMENT_REQUEST,
  CANCEL_APPOINTMENT_SUCCESS,
  CANCEL_APPOINTMENT_FAILURE,
  UPDATE_APPOINTMENT_REQUEST,
  UPDATE_APPOINTMENT_SUCCESS,
  UPDATE_APPOINTMENT_FAILURE,
} from "./AppointmentTypes";

import {
  fetchLeadAppointments,
  bookAppointment,
  fetchAppointments,
  cancelAppointment,
  checkSlotAvailability,
  updateAppointment
} from "../../services/AppointmentService";

import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

export const fetchAppointmentsLeadAction = (leadId, patientId) => {
  return async (dispatch) => {
    console.log("🔥 fetchAppointmentsLeadAction triggered:", { leadId, patientId });

    dispatch({ type: FETCH_APPOINTMENTS_REQUEST });
    
    try {
      const response = await fetchLeadAppointments(leadId, patientId);
      console.log("API Response:", response.data);

      if (response.data?.status === "success") {
        dispatch({
          type: FETCH_APPOINTMENTS_SUCCESS,
          payload: response.data.data,
        });
        console.log("API call payload:", { leadId, patientId });

        return response.data.data;
        
      } else {
        throw new Error(response.data?.message || "Failed to fetch appointments");
      }
    } catch (error) {
      dispatch({
        type: FETCH_APPOINTMENTS_FAILURE,
        payload: error.message,
      });
      showErrorAlert(error.message); // ✅ fixed
      throw error;
    }
  };
};

export const bookAppointmentAction = (appointmentData) => {
  return async (dispatch) => {
    dispatch({ type: BOOK_APPOINTMENT_REQUEST });
    try {
      const response = await bookAppointment(appointmentData);
      if (response.data?.status === "success") {
        dispatch({
          type: BOOK_APPOINTMENT_SUCCESS,
          payload: response.data.data,
        });
        handleSuccess.success("Appointment booked successfully");
        return response.data;
      } else {
        throw new Error(response.data?.message || "Failed to book appointment");
      }
    } catch (error) {
      dispatch({
        type: BOOK_APPOINTMENT_FAILURE,
        payload: error.message,
      });
      showErrorAlert.error(error.message);
      throw error;
    }
  };
};

export const fetchAppointmentsAction = (leadId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_APPOINTMENTS_REQUEST });
    try {
      const response = await fetchAppointments(leadId);
      if (response.data?.status === "success") {
        dispatch({
          type: FETCH_APPOINTMENTS_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      } else {
        throw new Error(
          response.data?.message || "Failed to fetch appointments"
        );
      }
    } catch (error) {
      dispatch({
        type: FETCH_APPOINTMENTS_FAILURE,
        payload: error.message,
      });
      showErrorAlert(error.message);
      throw error;
    }
  };
};

export const cancelAppointmentAction = (appointmentId) => {
  return async (dispatch) => {
    dispatch({ type: CANCEL_APPOINTMENT_REQUEST });
    try {
      const response = await cancelAppointment(appointmentId);
      if (response.data?.status === "success") {
        dispatch({
          type: CANCEL_APPOINTMENT_SUCCESS,
          payload: appointmentId,
        });
        handleSuccess("Appointment cancelled successfully");
        return response.data;
      } else {
        throw new Error(
          response.data?.message || "Failed to cancel appointment"
        );
      }
    } catch (error) {
      dispatch({
        type: CANCEL_APPOINTMENT_FAILURE,
        payload: error.message,
      });
      showErrorAlert(error.message);
      throw error;
    }
  };
};

export const checkSlotAvailabilityAction = async (date, timeSlot) => {
  try {
    const response = await checkSlotAvailability(date, timeSlot);
    return (
      response.data?.status === "success" && response.data?.data?.available
    );
  } catch (error) {
    console.error("Error checking slot availability:", error);
    return false;
  }
};

export const updateAppointmentAction = (appointmentData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_APPOINTMENT_REQUEST });
    try {
      const response = await updateAppointment(appointmentData);
      if (response.data?.status === "success") {
        dispatch({
          type: UPDATE_APPOINTMENT_SUCCESS,
          payload: response.data.data,
        });
        handleSuccess.success("Appointment updated successfully");
        return response.data;
      } else {
        throw new Error(response.data?.message || "Failed to update appointment");
      }
    } catch (error) {
      dispatch({
        type: UPDATE_APPOINTMENT_FAILURE,
        payload: error.message,
      });
      showErrorAlert.error(error.message);
      throw error;
    }
  };
};
